import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mobile } from 'yola-bowser';
import { utils } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';

const { ColorCircle, HorizontalStack, Box, Stack, Heading } = designSystem;

function ColorListPanel({ title, items, onSelect = utils.noop }) {
  return (
    <Box
      paddingTop="spacing-xs"
      paddingBottom="spacing-s"
      paddingLeft="spacing-m"
      paddingRight="spacing-m"
    >
      <Stack gap="spacing-3-xs">
        <Heading type="heading-6">{title}</Heading>
        <div
          className={classNames('ws-color-list-panel', {
            'ws-color-list-panel--mobile': mobile,
          })}
        >
          <HorizontalStack rowGap="spacing-3-xs" gap="spacing-3-xs" wrap>
            {items.map((item) => (
              <div
                key={item.id}
                className="ws-color-list-panel__item"
                onClick={() => onSelect(item)}
              >
                <ColorCircle color={item.value} opacity={item.opacity} />
              </div>
            ))}
          </HorizontalStack>
        </div>
      </Stack>
    </Box>
  );
}

ColorListPanel.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      opacity: PropTypes.number,
    })
  ).isRequired,
  onSelect: PropTypes.func,
};

export default ColorListPanel;
